// extracted by mini-css-extract-plugin
export default {"container":"Checkbox_container__BWOFX","checkmark":"Checkbox_checkmark__gVt5U","radioCheckmark":"Checkbox_radioCheckmark__Cd6q+","colorBox":"Checkbox_colorBox__kIckm"};